import { palette } from '@app/shared/ui-kit/colors';
import { Permission } from '@app/types/blackroom-api';
import { TFunction } from 'i18next';

const getPermissionVariant = (isGranted: boolean, isInherited: boolean) => {
  return isGranted || isInherited ? 'light' : 'subtle';
};

const getPermissionColor = (isGranted: boolean, isMixed: boolean) => {
  if (isGranted) return 'blackroomBlue';
  if (isMixed) return 'blackroomOrange';
  return 'blackroomGray';
};

const getPermissionBorderColor = (
  isGranted: boolean,
  isInherited: boolean,
  isMixed: boolean,
) => {
  if (isInherited) return palette.blackroomGray;
  if (isGranted) return palette.blackroomBlue;
  if (isMixed) return palette.blackroomOrange;
  return 'transparent';
};

const getTooltipLabel = (
  t: TFunction<'translation', undefined>,
  permission: Permission,
  isGranted: boolean,
  isInherited: boolean,
  isMixed: boolean,
  hasViewPermission: boolean,
) => {
  if (isGranted) return t(`Permission:Common.${permission}`);
  if (isInherited) return t('Permission:Common.isInherited');
  if (isMixed) return t(`Permission:Common.mixed.${permission}`);
  if (permission === Permission.ResourceDownload && !hasViewPermission)
    return t('Permission:Common.cannotSelectDownload');
  return t(`Permission:Common.${permission}`);
};

export {
  getPermissionColor,
  getPermissionBorderColor,
  getTooltipLabel,
  getPermissionVariant,
};
